import { FunctionalComponent, h } from '@stencil/core';

interface TimerAnimationProps {
  duration: number;
}

export const TimerAnimation: FunctionalComponent<TimerAnimationProps> = ({ duration }) => {
  return (
    <div class="pie" style={{ '--duration': `${duration}ms` }}>
      <div class="slice spinner" />
      <div class="slice filler" />
      <svg class="progress-spinner" viewBox="0 0 100 100" version="1.1" xmlns="http://www.w3.org/2000/svg">
        <circle class="progress"></circle>
      </svg>
    </div>
  );
};
